var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM14.4053 7.14668C14.6585 6.89354 14.6582 6.48293 14.4048 6.22954L13.8695 5.69415C13.6161 5.44076 13.2055 5.44056 12.9523 5.69368L10.0978 8.5482L10.0392 8.60679L9.97967 8.54721L7.12514 5.69269C6.872 5.43955 6.46141 5.43979 6.20804 5.69317L5.67264 6.22856C5.41924 6.48197 5.41902 6.89256 5.67215 7.14568L8.52666 10.0002L8.58623 10.0598L5.79181 12.8542C5.53867 13.1073 5.53891 13.5179 5.79229 13.7713L6.32768 14.3067C6.58109 14.5601 6.99168 14.5603 7.2448 14.3072L10.0392 11.5128L12.8327 14.3062C13.0858 14.5593 13.4964 14.5591 13.7498 14.3057L14.2852 13.7703C14.5386 13.517 14.5388 13.1063 14.2856 12.8532L11.4922 10.0598L11.5508 10.0012L14.4053 7.14668Z",
    fill: "#A8ADB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.2be09a504601f8e1e10f958fcb2af4ed.svg";
export { ForwardRef as ReactComponent };